<template>
    <forge-hub-classic v-if="classic" @layout="setLayout" />
    <forge-hub v-else @layout="setLayout" />
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import ForgeHub from '@/components/ForgeHub.vue';
import ForgeHubClassic from '@/components/ForgeHubClassic.vue';

// The Forge page (/ai-hub). November 2026 cleanup (Keelan: "the Forge needs to be cleaned up"): the new layout is
// components/ForgeHub.vue. The old one stays as components/ForgeHubClassic.vue so anyone can switch back at once:
// the link at the bottom of either page, or /ai-hub?layout=classic (and ?layout=new), remembered in this browser.
// To put everyone back on the old layout, set DEFAULT_LAYOUT to 'classic' (or revert the cleanup PR).
const DEFAULT_LAYOUT = 'new';
const KEY = 'forgeLayout';

function savedLayout(): string {
    try { return localStorage.getItem(KEY) || ''; } catch { return ''; }
}

export default defineComponent({
    name: 'AIHub',
    components: { ForgeHub, ForgeHubClassic },
    data() {
        const asked = String(this.$route.query.layout || '');
        const layout = [ 'new', 'classic' ].includes(asked) ? asked : (savedLayout() || DEFAULT_LAYOUT);
        return { classic: layout == 'classic' };
    },
    created() {
        const asked = String(this.$route.query.layout || '');
        if ([ 'new', 'classic' ].includes(asked)) {
            this.remember(asked);
            const query: any = { ...this.$route.query };
            delete query.layout;
            this.$router.replace({ query, hash: this.$route.hash });
        }
    },
    methods: {
        remember(layout: string) {
            try { localStorage.setItem(KEY, layout); } catch { /* private window: this visit only */ }
        },
        setLayout(layout: string) {
            this.remember(layout);
            this.$store.state.routeLoaded = false;
            this.classic = layout == 'classic';
            window.scrollTo(0, 0);
        }
    }
});
</script>
